<template>
	<TopNavFooter>
    <div class="main-content" id="admin" style="">
      <spinner :spinnerOn="loading"></spinner>
        <div class="container-fluid" style="background: #fff;padding: 0px;padding-top:35px;">
	        <div class="modal deleteConfirmModal" role="dialog" aria-hidden="true">
	          <div class="modal-dialog">
              <div class="modal-content" style="color: #00524A;">
                <div class="modal-header" style="display: block;">
		              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.delete}}</div>
                  <button type="button" class="close" data-dismiss="modal" style="background:#ffffff !important;color:#000 !important">&times;</button>
		              <h4 style="font-size: 18px;"></h4>
                </div>
                <div class="modal-body">
		              <div style="margin-right: 233px;width: 100%;text-align: left;">
		                <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12"
		                style="font-size: 18px;font-weight:normal !important;">{{user_lang.wanttodeleteadminconfig}} </label>
		              </div>
		              <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="removeConfirm()" style="margin-top: 15px;">{{user_lang.yes}}</a>
		              <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
                  <!--div class="col-12" style="margin-bottom: 15px;color: green;" v-show="resetSuccess"> Successfully Updated. </div -->
	              </div>
	            </div>
	          </div>
          </div>
	        <div class="modal cannotDeleteModal" role="dialog" aria-hidden="true">
	          <div class="modal-dialog">
              <div class="modal-content" style="color: #00524A;">
                <div class="modal-header" style="display: block;border:0px !important;">
		              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="float: left;width: 90%;margin: 10px;">{{user_lang.cannotdeleteconfig}}</div>
                  <button type="button" class="close" data-dismiss="modal" style="background:#ffffff !important;color:#000 !important">&times;</button>
		              <h4 style="font-size: 18px;"></h4>
                </div>
	            </div>
	          </div>
          </div>
          <!-- BEGIN: CONTAINER -->
          <div class="container">
	          <div style="margin:-15px">
	            <div class="bc-adduser">
                <div style="font-size: 44px !important;font-weight: bold;overflow: auto;margin-bottom: 15px;"><span>{{user_lang.tmlabel}}</span>
	              </div>
	            </div>
	          </div>
	          <div style="font-size: 14px;margin: 10px 0px;">
	            Note: Ensure that the configured groups are as allowed by the access rules and the service account permissions set in the Okta admin console.
              <div>Internal User groups should not be configured to be managed by this application.</div>
            </div>
		        <!--div v-for = "i in clientList">{{i.clientId}}</div-->
            <div v-show="showAppList">
              <div class="row" style="padding: 10px 10px;">
                <div class="col-6">
                  <input class="form-control search-app" placeholder="Search Application" type="text" id="search-criteria"/>
                  <i class="fa fa-search"></i>
                </div>
                <div class="col-6" style="text-align:right; padding: 10px">
                  <button @click="addConfigRow(); changeToAppView()" style="margin-right: 15px;line-height: 16px;cursor:pointer;border-radius:2px;">Add New App</button>
                </div>
              </div>
              <div class="row" style="border: 1px solid #000; background: #213031; padding: 10px 10px;">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div style="color:#fff; font-weight:bold">Applications</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                  <div style="color:#fff; font-weight:bold">Brand</div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                  <div style="color:#fff; font-weight:bold">Action</div>
                </div>
              </div>
              <div class="row searchbox" v-for="(x, index) in appNameList" :key="x.id + '~' + index" style="padding: 5px 10px; border-bottom: 8px solid #eceff1; background-color: #FFFFFF;">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" :class="{disabled: x.label.indexOf('Deleted App') > -1}">
                  <div class="app-name list" @click="getApplicationGroups(appAdminGroupModal[index].applicationId, index);"><a style="cursor:pointer">{{x.label}}</a></div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                  <div class="app-name" style="pointer-events: none; text-transform: capitalize;">{{appAdminGroupModal[index].brand}}</div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                  <button @click="removeRow(appAdminGroupModal[index].appGrpId, index, appAdminGroupModal[index].applicationId)" class="deleteconfig">Delete</button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin:15px;color:green" v-show="deleteSuccess">{{user_lang.adminconfigdeletesuccess}}</div>
              </div>
            </div>
            <div v-show="!showAppList">
              <div class="row" style="padding: 10px">
                <div style="font-size: 20px; font-weight: bolder; padding-left: 5px;" class="appDetails">App Configuration</div>
              </div>
              <div class="row" style="padding: 10px">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">Application</div>
                  <span>
                    <select class="dropdownWrap" :id="'select'+ appAdminGroupModal[applicationIndex].applicationId" style="width:100%;" v-model = "appAdminGroupModal[applicationIndex].applicationId"
		                  @change="getGroups(appAdminGroupModal[applicationIndex].applicationId)"
		                  :class = "{disabledLight: appAdminGroupModal[applicationIndex].applicationId !== undefined &&
		                  appAdminGroupModal[applicationIndex].applicationId !== 'undefined' && appAdminGroupModal[applicationIndex].groupId !== 'undefined'}">
		                  <option value="undefined">{{user_lang.selectapp}}</option>
		                  <option :value="j.id" :key="j.id" v-for = "j in appList" v-if="j.name !== 'bookmark'" v-show = "appAdminGroupModal[applicationIndex].appGrpId === undefined">{{j.label}}</option>
		                </select>
                  </span>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">Brand</div>
                  <span>
                    <select class="dropdownWrap" :id="'selectbrand'+ appAdminGroupModal[applicationIndex].applicationId" style="width:100%;" v-model = "appAdminGroupModal[applicationIndex].brand" 
                      :class="{disabledLight: appAdminGroupModal[applicationIndex].appGrpId !== undefined && 
                      appAdminGroupModal[applicationIndex].appGrpId !== ''}">
                      <option value="undefined">{{user_lang.selectBrand}}</option>
                      <option :value="j.brandKey" :key="j.brandKey" v-for = "j in brandDetails.data">{{j.brandName}}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.admingroup}}</div>
                  <span>
                    <!-- <select class="dropdownWrap" :id="appAdminGroupModal[applicationIndex].applicationId" style="width:100%" v-model = "appAdminGroupModal[applicationIndex].groupId"
                      :class = "{disabledLight: appAdminGroupModal[applicationIndex].applicationId !== undefined &&
                      appAdminGroupModal[applicationIndex].applicationId !== 'undefined' && appAdminGroupModal[applicationIndex].groupId !== 'undefined'}"
                      @change="populateOptionDetails(appAdminGroupModal[applicationIndex].applicationId, applicationIndex)">
                      <option value="undefined">{{user_lang.selectadmingroup}}</option>
                      <option :value="j.id" :key="j.id" v-for = "j in appsGroups[appAdminGroupModal[applicationIndex].applicationId]">{{j._embedded.group.profile.name}}</option>
                    </select> -->
                    <input type="text" tabindex="-1" :class="{disabledLight: appAdminGroupModal[applicationIndex].appGrpId !== undefined && appAdminGroupModal[applicationIndex].appGrpId !== ''}" style="height: 40px !important; width: 75%; font-size: 16px !important;" v-on:keydown="onSearch()" v-model="groupNameTyped" placeholder="Search group name" />
                    <div id="dropdown" style="width:75%">
                      <div class="searchDropDown" v-if="isSearched && groupNameTyped.length > 0">
                        <div :key="j.id" v-for="j in searchDropdownData">
                          <div class="search-list-for-admin" :for = "j.id" @click="selectAdminGroupFromList(j)">{{j.profile.name}}</div>
                        </div>
                        <div v-if="searchDropdownData.length === 0"><i>No groups found.</i></div>
                      </div>
                    </div>
                  </span>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.administeredgroups}}</div>
                  <span>
                    <div id="dropdown" style="width:75%">
			                <div class="selectDropDown" v-on:click="openDropDown(applicationIndex)">
			                  <span style="display: flex;justify-content: space-between;margin-top: 5px;padding-left: 10px;">
                          <span v-if="appAdminGroupModal[applicationIndex].subGroupId && appAdminGroupModal[applicationIndex].subGroupId.length == 0">
			                      {{user_lang['selectgroupslist']}} 
                          </span>
			                    <span v-if="appAdminGroupModal[applicationIndex].subGroupId && appAdminGroupModal[applicationIndex].subGroupId.length > 0">
  			                    Selected ({{appAdminGroupModal[applicationIndex].subGroupId ? appAdminGroupModal[applicationIndex].subGroupId.length : '0'}})
                          </span>
			                    <i class="fa fa-caret-down" style="float: right;margin: 4px 5px;"></i>
                        </span>
                      </div>
			                <div id="checkboxlist" v-show="showDropdownForGroups" :class="'ddwrap'+applicationIndex">
					              <div :key="j.id" v-for="j in currGroupDetails" style="padding-right: 15px;padding-left: 5px;" class="dd-list-item">
					                <input :id="j.id + '~' + applicationIndex" class="form-control input-checkbx-sub" type="checkbox" :value="j._embedded.group.profile.name" @change="checkchange($event)" />
					                <label style="vertical-align: super;" :for="j.id">{{j._embedded.group.profile.name}}</label>
					              </div>
					              <div :key="j.id" v-for="j in appAdminGroupModal[applicationIndex].subGroupId" 
					                v-if="j.indexOf('~~~') > -1 && !currGroupDetails.some(x => x.id.indexOf(j.id) > -1)"
					                style="padding-right: 15px;padding-left: 5px;" class="dd-list-item">
                				  <input :id="j.split('~~~')[0] + '~' + applicationIndex" class="form-control input-checkbx-sub"
					                  type="checkbox" :value="j.split('~~~')[1]" @change="checkchange($event)" />
					                <label style="vertical-align: super;" :for="j.split('~~~')[0]">{{j.split('~~~')[1]}}</label>
					              </div>
					            </div>
			              </div>
                    <div style="text-align:right; color: #658d1b; font-weight: 600;" v-if="appAdminGroupModal[applicationIndex].subGroupId.length > 0"> Read Only </div>
			              <span :key="j.subGroupId" v-for="j in appAdminGroupModal[applicationIndex].subGroupManagement" style="display: block; padding: 5px">
                      <span v-if="!j.roleChanged">{{j.subGroupName}}
                        <label style="float:right" class="switch">
                          <input type="checkbox" v-model="j.isReadOnly" />
                          <div class="slider round"></div>
                        </label>
                      </span>
                      <span v-else-if="j.roleChanged">{{j.subGroupName}}
                        <i class="fa fa-remove-circle"></i>
                      </span>
                      <!-- <span v-else-if="j.subGroupId.split('~~~') > -1">{{j.subGroupId.split('~~~')[1]}}
                        <label style="float:right" class="switch">
                          <input type="checkbox" v-model="appAdminGroupModal[applicationIndex].subGroupsMap[j.subGroupId]" />
                          <div class="slider round"></div>
                        </label>
                      </span> -->
                      <!-- <span v-if="currGroupIds && currGroupIds.indexOf(j.subGroupId) !== -1">-1.{{j.subGroupName}}
                        <label style="float:right" class="switch">
                          <input type="checkbox" v-model="appAdminGroupModal[applicationIndex].subGroupsMap[j.subGroupId]" />
                          <div class="slider round"></div>
                        </label>
                      </span>
                      <span v-else-if="j.subGroupId.indexOf('~~~') === -1 && currGroupIds.indexOf(j.subGroupId) === -1">-2.{{j.subGroupName}}
                        <i class="fa fa-remove-circle"></i>
                      </span>
                      <span v-else-if="j.subGroupId.indexOf('~~~') > -1 && currGroupIds.indexOf(j.subGroupId.split('~~~')[0]) > -1">-3.{{j.subGroupName}}
                        <i class="fa fa-remove-circle"></i>
                      </span>
                      <span v-else>-4.{{j.subGroupId.split('~~~')[1]}}
                        <label style="float:right" class="switch">
                          <input type="checkbox" v-model="appAdminGroupModal[applicationIndex].subGroupsMap[j.subGroupId]" />
                          <div class="slider round"></div>
                        </label>
                      </span> -->
                    </span>
			              <!-- <span :key="j.id" v-for="j in appAdminGroupModal[applicationIndex].subGroupId" v-if="j.indexOf('~~~') > -1 && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId] && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1"
			              style="display: block; padding: 5px">-{{j.split('~~~')[1]}}
                      <label style="float:right" class="switch">
                        <input type="checkbox" v-model="appAdminGroupModal[applicationIndex].subGroupsMap[j]" />
                        <div class="slider round"></div>
                      </label>
                    </span> -->
			              <div style="font-weight:600;margin-top: 5px;">Administer additional group:</div>
			              <input type ="text" class="addgrouptxtbox" v-model="additionalGroup[applicationIndex]" placeholder="Enter group name and click +"/>
			              <i class="fa fa-plus-circle" style="font-size: 20px;cursor: pointer;color: rgb(101, 141, 27);margin-left: 10px;" @click="addAdditionalGroup(applicationIndex, appAdminGroupModal[applicationIndex].applicationId)"></i>
                  </span>
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.isDxpApp}}</div>
                  <label style="font-size:16px;">
                    <input :id="'select'+ appAdminGroupModal[applicationIndex].applicationId" style="width:25px;vertical-align: middle;" type="checkbox" v-model="appAdminGroupModal[applicationIndex].isDxp" />
                    {{user_lang.dxpActivation}}
                  </label>
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div style="font-size: 20px; font-weight: bolder; padding-left: 5px;" class="appDetails">{{user_lang.selfRegistration}}</div>
              </div>
              <div class="row" style="padding: 10px">
                <div style="padding-top: 15px" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <!-- <div class="appDetails">{{user_lang.selfRegistration}}</div> -->
                  <div>
                    <label style="font-size:16px;">
                      <input :id="'chkSelf'+ appAdminGroupModal[applicationIndex].applicationId" style="width:25px;vertical-align: middle;" type="checkbox" v-model="appAdminGroupModal[applicationIndex].isSelfReg" />
                      {{user_lang.selfRegistration}}
                    </label>
                  </div>
                  <div style="padding-top: 10px">
                    <label style="font-size:16px;">
                      <input :id="'chkDisableExistingUserOnboard'+ appAdminGroupModal[applicationIndex].applicationId" 
                        style="width:25px;vertical-align: middle;" type="checkbox" 
                        v-model="appAdminGroupModal[applicationIndex].disableExistingUserOnboard" 
                        :class = "{disabledLight: !appAdminGroupModal[applicationIndex].isSelfReg}"
                        :disabled="!appAdminGroupModal[applicationIndex].isSelfReg"
                      />
                      {{user_lang.disableExistingUserOnboard}}
                    </label>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.selfRegistrationEmailId}}</div>
                  <input class="addgrouptxtbox" :id="'txtEmail'+ appAdminGroupModal[applicationIndex].applicationId" 
                    style="vertical-align: middle; height: 40px !important; font-size: 16px !important;" 
                    type="text" v-model="appAdminGroupModal[applicationIndex].emailId" />
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.selfApp}}</div>
                  <select class="dropdownWrap" :id="'selRegGroup'+ appAdminGroupModal[applicationIndex].applicationId" style="width:100%" v-model = "appAdminGroupModal[applicationIndex].selfRegGroupId"
                    :class = "{disabledLight: appAdminGroupModal[applicationIndex].isSelfRegModal || !appAdminGroupModal[applicationIndex].isSelfReg}"
                    @change="populateOptionDetails(appAdminGroupModal[applicationIndex].applicationId, applicationIndex)">
                    <option value="undefined">{{user_lang.selectReggroup}}</option>
                    <option :value="j.id" :key="j.id" v-for = "j in appsSelfGroups[appAdminGroupModal[applicationIndex].applicationId]">{{j._embedded.group.profile.name}}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.selfRegGrp}}</div>
                  <div id="dropdown" style="width:75%">
			              <div class="selectDropDown" v-on:click= "openSelfRegDropDown(applicationIndex)"
                      :class = "{disabledLight: !appAdminGroupModal[applicationIndex].isSelfReg}">
			                <span style="display: flex;justify-content: space-between;margin-top: 5px;padding-left: 10px;">
                        <span v-if="!appAdminGroupModal[applicationIndex].selfRegGroupList || (appAdminGroupModal[applicationIndex].selfRegGroupList && appAdminGroupModal[applicationIndex].selfRegGroupList.length == 0)">
			                    {{user_lang['selectgroupslist']}} 
                        </span>
			                  <span v-if="appAdminGroupModal[applicationIndex].selfRegGroupList && appAdminGroupModal[applicationIndex].selfRegGroupList.length > 0">
			                    Selected ({{appAdminGroupModal[applicationIndex].selfRegGroupList ? appAdminGroupModal[applicationIndex].selfRegGroupList.length : '0'}})
                        </span>
			                  <i class="fa fa-caret-down" style="float: right;margin: 4px 5px;"></i>
                      </span>
                    </div>
			              <div id="checkboxlist" v-show="showDropdownForSelfGroups" :class="'ddwrapself'+applicationIndex">
					            <div :key="j.id" v-for="j in appsSelfGroups[appAdminGroupModal[applicationIndex].applicationId]" style="padding-right: 15px;padding-left: 5px;" class="dd-list-item">
					              <input :id = "j.id + '~self' + applicationIndex" class="form-control input-checkbx-sub" type="checkbox" :value = "j.id" @change="checkSelfchange($event)" />
					              <label style="vertical-align: super;" :for = "j.id">{{j._embedded.group.profile.name}}</label>
					            </div>
					            <div :key="j.id" v-for="j in appAdminGroupModal[applicationIndex].selfRegGroupList" 
					              v-if="j.indexOf('~~~') > -1 && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId] && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1"
					              style="padding-right: 15px;padding-left: 5px;" class="dd-list-item">
					              <input :id = "j.split('~~~')[0] + '~self' + applicationIndex" class="form-control input-checkbx-sub"
					              type="checkbox" :value = "j.split('~~~')[0]" @change="checkSelfchange($event)" />
					              <label style="vertical-align: super;" :for = "j.split('~~~')[0]">{{j.split('~~~')[1]}}</label>
					            </div>
					          </div>
			            </div>
			            <span :key="j.id" v-for="j in appsSelfGroups[appAdminGroupModal[applicationIndex].applicationId]" v-if="appAdminGroupModal[applicationIndex].selfRegGroupList && appAdminGroupModal[applicationIndex].selfRegGroupList.indexOf(j.id) > -1" 
			              style="display: block; padding: 5px">-{{j._embedded.group.profile.name}}</span>
			            <span :key="j.id" v-for="j in appAdminGroupModal[applicationIndex].selfRegGroupList" v-if="j.indexOf('~~~') > -1 && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId] && appGroupsArrayMap[appAdminGroupModal[applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1"
			              style="display: block; padding: 5px">-{{j.split('~~~')[1]}}</span>
			            <div style="font-weight:600;margin-top: 5px;">{{user_lang.selfRegSubGrps}}</div>
			            <input type ="text" class="addgrouptxtbox" v-model="additionalSelfGroup[applicationIndex]" placeholder="Enter group name and click +"
                  :class = "{disabledLight: !appAdminGroupModal[applicationIndex].isSelfReg}"/>
			            <i class="fa fa-plus-circle" style="font-size: 20px;cursor: pointer;color: rgb(101, 141, 27);margin-left: 10px;" @click="addAdditionalSelfGroup(applicationIndex, appAdminGroupModal[applicationIndex].applicationId)"></i>
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="appDetails">{{user_lang.maxNoUsers}}</div>
                  <input :id="'txtSelf'+ appAdminGroupModal[applicationIndex].applicationId" 
                    style="width:75px;vertical-align: middle;height: 40px !important; font-size: 16px !important;" 
                    type="text" v-model="appAdminGroupModal[applicationIndex].maxSelfRegCount" 
                    :class = "{disabledLight: !appAdminGroupModal[applicationIndex].isSelfReg}"
                  />
                </div>
              </div>
              <div class="row">
	              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin:15px;color:red" v-show="isIncomplete">
	              {{user_lang.adminConfigIncomplete}}</div>
	              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin:15px;color:green" v-show="saveSuccess">
	              {{user_lang.adminconfigupdatesuccess}}</div>
	            </div>
	            <div class="row">
	              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align:right;">
                  <button style="margin-right: 15px; line-height: 16px; cursor: pointer; font-size: 17px; border-radius: 2px;" @click="changeView()">Back</button>
	                <button @click="saveAdminGroups()" style="margin-right: 15px;line-height: 16px;cursor:pointer;font-size: 17px;border-radius:2px;">{{user_lang.save}}</button>
	                <!-- <button @click="addConfigRow()" style="margin-right: 15px;line-height: 16px;cursor:pointer;border-radius:2px;">Add New Config</button> -->
	              </div>
	            </div>
            </div>
	        </div>  <!-- END: container -->
        </div>
    </div>
  </TopNavFooter>
</template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage';
  import Vue from 'vue';
  const apiUrl = process.env.API_URL;
  const onecargillappid = process.env.KEY_ID;
  // const brandDetails = require('../brand-details.json');
  let environment = process.env.NODE_ENV;
  let brandDetails = "";
  console.log('env=====', environment);
  if (environment === 'production') {
    brandDetails = require('../brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('../brand-details-stage.json');
  } else {
    brandDetails = require('../brand-details-dev.json');
  }
  export default {
    name: 'tm',
    components: {
      TopNavFooter,
      Spinner
    },
    created() {
      // this.changeCustomer();
      var self = this;
      self.loading = true
      self.userId = storage.get('cf-user').sub
      self.email = storage.get('email')
      this.user_lang = this.lang_br
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
      self.getListOfSuperUserApps()
    },
    mounted () {
      var self = this
      // var tempshowDropDown = {};
      // var tempshowSelfDropDown = {};
      // for (var i = 0; i < 100; i++) {
      //   tempshowDropDown[i.toString()] = false
      //   tempshowSelfDropDown[i.toString()] = false;
      // }
      // self.showDropDown = tempshowDropDown
      // self.showSelfDropDown = tempshowSelfDropDown;
      $(document).ready(function() {
        $('[data-toggle="tooltip"]').tooltip();
      });
      $("#search-criteria").on("keyup", function() {
        self.clearMessages()
        var g = $(this).val().toLowerCase();
        $(".searchbox .list").each(function () {
          var s = $(this).text().toLowerCase();
          // console.log(s + '\n' + g)
          $(this).closest('.searchbox')[ s.indexOf(g) !== -1 ? 'show' : 'hide' ]();
        });
      });
      $(document).on('click', 'body', function (e) {
        if (!$('div#dropdown').has(e.target).length) {
          // var tempshowDropDown = {}
          // var tempshowSelfDropDown = {};
          // for (var i = 0; i < 100; i++) {
          //   tempshowDropDown[i.toString()] = false
          //   tempshowSelfDropDown[i.toString()] = false;
          // }
          // self.showDropDown = tempshowDropDown
          // self.showSelfDropDown = tempshowSelfDropDown;
        }
      })
      /* $(document).on('change', '.input-checkbx-sub', function (e) {
        var grpid = (e.target.id.split('~')[0])
        var idx = (e.target.id.split('~')[1])
        // console.log(self.appAdminGroupModal)
        if (self.appAdminGroupModal[idx].subGroupId === undefined) {
          self.appAdminGroupModal[idx]['subGroupId'] = []
        }
        if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
          self.appAdminGroupModal[idx].subGroupId.push(grpid)
        } else {
          self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(e => e !== grpid);
        }
        // console.log(self.appAdminGroupModal)
      }) */
    },
    watch: {
      appAdminGroupModal: function () {
        this.watchAppAdminGroupModal()
      }
    },
    methods: {
      watchAppAdminGroupModal() {
        var self = this
        console.log('watch')
        if (this.appAdminGroupModal.length === 0) {
          var newRowObj = $.extend(true, {}, self.rowObj)
          self.appAdminGroupModal.push(newRowObj)
        }
      },
      selectAdminGroupFromList(groupDetails) {
        var self = this
        console.log(groupDetails)
        console.log(self.applicationIndex)
        self.isSearched = false
        self.groupNameTyped = groupDetails.profile.name
        self.appAdminGroupModal[self.applicationIndex].groupId = groupDetails.id
      },
      onSearch() {
        var self = this
        self.appAdminGroupModal[self.applicationIndex].groupId = ""
        if (self.groupNameTyped.length > 1) {
          self.loading = true
          clearTimeout(self.timer)
          self.timer = setTimeout(function() {
            idmApi.getGroupByName(`${apiUrl}/auth/groups/search?limit=10&groupName=${self.groupNameTyped}`).then(response => {
              self.isSearched = true
              self.loading = false
              self.searchDropdownData = response.data
              console.log(response)
            }).catch(err => {
              self.loading = false
              console.log(err)
            })
          }, 1000)
        }
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      addAdditionalGroup (index, appid) {
        var self = this
        self.loading = true
        idmApi.getGroupByName(`${apiUrl}/auth/groups/search?groupName=${self.additionalGroup[index]}`).then(response => {
          self.addAdditionalGroupImpl(response, index, appid)
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      addAdditionalSelfGroup(index, appid) {
        var self = this
        self.loading = true
        idmApi.getGroupByName(`${apiUrl}/auth/groups/search?groupName=${self.additionalSelfGroup[index]}`).then(response => {
          self.addAdditionalGroupSelfImpl(response, index, appid)
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      addAdditionalGroupSelfImpl(response, index, appid) {
        var self = this
        self.loading = false
        if (response.data.length === 0) {
          window.alert('Please enter valid group name')
          self.additionalSelfGroup = []
        } else {
          var fl = self.appsSelfGroups[appid].filter(x => x.id === response.data[0].id)
          if (fl.length === 0) {
            var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name
            self.appAdminGroupModal[index].selfRegGroupList.push(indieSubGroupEntry.trim())
            self.tempAppAdminGroupModal = []
            self.appAdminGroupModal.forEach(function (x, index) {
              self.tempAppAdminGroupModal[index] = Object.assign({}, x);
            })
            self.additionalSelfGroup = []
          } else {
            window.alert('Please select this group from the dropdown')
            self.additionalSelfGroup = []
          }
        }
      },
      addAdditionalGroupImpl(response, index, appid) {
        var self = this
        // console.log(response)
        self.loading = false
        if (response.data.length === 0) {
          window.alert('Please enter valid group name')
          self.additionalGroup = []
        } else {
          // var fl = self.appsGroups[appid].filter(x => x.id === response.data[0].id)
          let fl = self.currGroupIds.indexOf(response.data[0].id) > -1
          if (!fl) {
            var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name
            indieSubGroupEntry = indieSubGroupEntry.trim()
            self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry)
            let obj = {subGroupId: indieSubGroupEntry, subGroupName: response.data[0].profile.name, isReadOnly: false, roleChanged: false}
            self.appAdminGroupModal[index].subGroupManagement.push(obj)
            self.tempAppAdminGroupModal = []
            self.appAdminGroupModal.forEach(function (x, index) {
              self.tempAppAdminGroupModal[index] = Object.assign({}, x);
            })
            self.additionalGroup = []
          } else {
            window.alert('Please select this group from the dropdown')
            self.additionalGroup = []
          }
        }
      },
      checkchange (e) {
        console.log(e)
        var self = this
        var grpid = (e.target.id.split('~')[0])
        var idx = (e.target.id.split('~')[1])
        var grpname = e.target.value
        if (self.appAdminGroupModal[idx].subGroupId === undefined) {
          self.appAdminGroupModal[idx]['subGroupId'] = []
        }
        if (self.appAdminGroupModal[idx].subGroupManagement === undefined) {
          self.appAdminGroupModal[idx]['subGroupManagement'] = []
        }
        if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
          let obj = {subGroupId: grpid, subGroupName: grpname, isReadOnly: false, roleChanged: false}
          self.appAdminGroupModal[idx].subGroupId.push(grpid)
          self.appAdminGroupModal[idx].subGroupManagement.push(obj);
        } else {
          self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(e => e.indexOf(grpid) === -1);
          self.appAdminGroupModal[idx].subGroupManagement = self.appAdminGroupModal[idx].subGroupManagement.filter(e => e.subGroupId.indexOf(grpid) === -1);
        }
      },
      checkSelfchange (e) {
        var self = this
        var grpid = (e.target.id.split('~self')[0])
        var idx = (e.target.id.split('~self')[1])
        if (self.appAdminGroupModal[idx].selfRegGroupList === undefined) {
          self.appAdminGroupModal[idx]['selfRegGroupList'] = []
        }
        if (e.target.checked && self.appAdminGroupModal[idx].selfRegGroupList.indexOf(grpid) === -1) {
          self.appAdminGroupModal[idx].selfRegGroupList.push(grpid)
        } else {
          self.appAdminGroupModal[idx].selfRegGroupList = self.appAdminGroupModal[idx].selfRegGroupList.filter(e => e.indexOf(grpid) === -1);
        }
      },
      openDropDown(index) {
        var self = this
        self.showDropdownForGroups = !self.showDropdownForGroups
        // self.showDropDown[index.toString()] = !self.showDropDown[index.toString()]
        if (self.appAdminGroupModal[index].subGroupId === undefined) {
          self.appAdminGroupModal[index]['subGroupId'] = []
        }
        for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
          var sel = ''
          if (self.appAdminGroupModal[index].subGroupId[i].indexOf('~~~') > -1) {
            sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split('~~~')[0] + '"]'
          } else {
            sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]'
          }
          $(sel).attr('checked', true)
        }
      },
      openSelfRegDropDown(index) {
        var self = this
        self.showDropdownForSelfGroups = !self.showDropdownForSelfGroups
        // self.showSelfDropDown[index.toString()] = !self.showSelfDropDown[index.toString()]
        if (self.appAdminGroupModal[index].selfRegGroupList === undefined) {
          self.appAdminGroupModal[index]['selfRegGroupList'] = []
        }
        for (var i = 0; i < self.appAdminGroupModal[index].selfRegGroupList.length; i++) {
          var sel = ''
          if (self.appAdminGroupModal[index].selfRegGroupList[i].indexOf('~~~') > -1) {
            sel = '.ddwrapself' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i].split('~~~')[0] + '"]'
          } else {
            sel = '.ddwrapself' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i] + '"]'
          }
          $(sel).attr('checked', true)
        }
      },
      getListOfClientId() {
        var self = this
        idmApi.getClientIds(`${apiUrl}/apitokenList`, self.email).then(function (response) {
          self.loading = false
          self.clientList = response.data
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      getListOfSuperUserApps() {
        var self = this
        self.clearMessages()
        idmApi.getListOfSuperUserApps(`${apiUrl}/auth/apps`, self.email).then(function (response) {
          self.loading = false
          self.appList = response.data
          self.appList.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
          self.getConfigList()
          /* for (var i = 0; i < response.data.length; i++) {
            self.getGroups(response.data[i].id)
          } */
        }).catch(err => {
          self.loading = false
          console.log(err)
        })
      },
      changeView() {
        var self = this
        if (self.isNewAppConfig) {
          self.tempAppAdminGroupModal = []
          self.appAdminGroupModal = self.appAdminGroupModal.slice(0, self.appAdminGroupModal.length - 1)
          self.appAdminGroupModal.forEach(function (x, index) {
            self.tempAppAdminGroupModal[index] = Object.assign({}, x);
          })
          self.applicationIndex = 0
          self.isNewAppConfig = false
        }
        self.isSearched = false
        self.showDropdownForGroups = false
        self.showDropdownForSelfGroups = false
        self.searchDropdownData = []
        self.showAppList = true
        window.scrollTo(0, 0);
      },
      changeToAppView() {
        var self = this
        self.clearMessages()
        self.applicationIndex = self.appAdminGroupModal.length - 1
        self.showAppList = false
        window.scrollTo(0, 0);
      },
      getApplicationGroups(id, index) {
        var self = this
        window.scrollTo(0, 0);
        self.applicationIndex = index
        self.showAppList = false
        self.getGroups(id, index)
        self.getAdminGroup(id, index)
      },
      checkForRoleChange(ind) {
        var self = this
        if (!self.showAppList) {
          return;
        }
        self.appAdminGroupModal[ind].subGroupManagement.map(group => {
          if ((group.subGroupId.indexOf('~~~') === -1 && self.currGroupIds.indexOf(group.subGroupId) === -1) ||
            (group.subGroupId.indexOf('~~~') > -1 && self.currGroupIds.indexOf(group.subGroupId.split('~~~')[0]) > -1)) {
            group.roleChanged = true;
          } else {
            group.roleChanged = false;
          }
        })
        console.log(self.appAdminGroupModal[ind].subGroupManagement)
      },
      getAdminGroup(applicationId, index) {
        var self = this
        idmApi.getAdminGroup(`${apiUrl}/auth/groups/${self.appAdminGroupModal[index].groupId}`).then(function (response) {
          console.log(response)
          self.groupNameTyped = response.data.profile.name
        }).catch(err => {
          console.log(err)
        })
      },
      getGroups(id, ind) {
        var self = this
        self.clearMessages()
        if (((self.appsGroups[id] === undefined && id !== 'undefined') || (self.appsSelfGroups[id] === undefined && id !== 'undefined')) && id !== undefined) {
          self.loading = true
          idmApi.getGroupsByAppId(`${apiUrl}/auth/apps/${id}/groups`).then(function (response) {
            self.loading = false
            self.currGroupDetails = response.data
            self.currGroupIds = []
            response.data.forEach(x => {
              self.currGroupIds.push(x.id)
            })
            self.checkForRoleChange(ind)
            var gmap = response.data.map(x => x.id)
            Vue.set(self.appGroupsArrayMap, id, gmap)
            Vue.set(self.appsGroups, id,
            response.data.sort((a, b) => (a._embedded.group.profile.name.toLowerCase() >
            b._embedded.group.profile.name.toLowerCase()) ? 1 : ((b._embedded.group.profile.name.toLowerCase() >
            a._embedded.group.profile.name.toLowerCase()) ? -1 : 0)))
            Vue.set(self.appsSelfGroups, id,
            response.data.sort((a, b) => (a._embedded.group.profile.name.toLowerCase() >
            b._embedded.group.profile.name.toLowerCase()) ? 1 : ((b._embedded.group.profile.name.toLowerCase() >
            a._embedded.group.profile.name.toLowerCase()) ? -1 : 0)))
            console.log('Apps Groups', self.appsGroups)
            console.log('Apps Self Groups', self.appsSelfGroups)
            console.log('Apps Groups Array Map', self.appGroupsArrayMap)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      addConfigRow() {
        var self = this
        self.clearMessages()
        self.groupNameTyped = ""
        var newRowObj = $.extend(true, {}, self.rowObj)
        self.appAdminGroupModal.push(newRowObj)
        self.tempAppAdminGroupModal.push(newRowObj)
        self.isNewAppConfig = true
      },
      getNamesOfApp() {
        var self = this
        self.appNameList = []
        self.appAdminGroupModal.forEach(function (x, index) {
          let arr = self.appList.filter(y => y.id === x.applicationId)[0]
          if (arr) {
            self.appNameList[index] = arr
            x.applicationName = self.appNameList[index].label
          } else {
            let val = {
              id: x.applicationId,
              label: x.applicationName + " - Deleted App"
            }
            self.appNameList[index] = val
            x.applicationName = val.label
          }
        })
        self.appNameList.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
        self.appAdminGroupModal.sort((a, b) => a.applicationName.toLowerCase().localeCompare(b.applicationName.toLowerCase()));
        console.log(self.appNameList)
        console.log(self.appAdminGroupModal)
      },
      getConfigList() {
        var self = this
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupListNew`).then(function (response) {
          self.appAdminGroupModal = response.data;
          self.tempAppAdminGroupModal = []
          self.appAdminGroupModal.forEach(function (x, index) {
            self.tempAppAdminGroupModal[index] = Object.assign({}, x);
          })
          self.getNamesOfApp();
          // if (self.appAdminGroupModal.length > 0) {
          //   self.appAdminGroupModal.map(function(i) {
          //     self.loading = true
          //     self.getGroups(i.applicationId)
          //     i.isSelfRegModal = i.isSelfReg;
          //   })
          // } else {
          //   self.addConfigRow()
          // }
        }).catch(err => {
          console.log(err)
        })
      },
      saveAdminGroups() {
        var self = this
        self.clearMessages()
        var filteredList = self.appAdminGroupModal[self.applicationIndex]
        if (filteredList.brand === 'undefined' || filteredList.brand === undefined || filteredList.groupId === 'undefined' ||
          filteredList.groupId === undefined || filteredList.groupId === '' || (filteredList.subGroupId && filteredList.subGroupId.length === 0) ||
          (filteredList.isSelfReg && (filteredList.emailId === undefined || filteredList.selfRegGroupId === 'undefined' ||
          filteredList.selfRegGroupList.length === 0 || filteredList.maxSelfRegCount === 0))) {
          self.isIncomplete = true
        }
        if (!self.isIncomplete) {
          self.loading = true;
          if (self.isNewAppConfig) {
            self.isNewAppConfig = false
          }
          filteredList.adminGroupName = self.groupNameTyped
          filteredList.email = self.email
          filteredList.isSelfRegModal = filteredList.isSelfReg
          if (!filteredList.isSelfReg) {
            filteredList.maxSelfRegCount = 0;
            delete filteredList.selfRegGroupList;
            delete filteredList.selfRegGroupId;
          }
          if (!filteredList.applicationName) {
            filteredList.applicationName = self.appList.filter(y => y.id === filteredList.applicationId)[0].label
          }
          console.log(self.currGroupDetails)
          filteredList.subGroupManagement.forEach(grp => {
            if (grp.roleChanged) {
              if (grp.subGroupId.indexOf('~~~') > -1) {
                let newGroup = grp.subGroupId.split('~~~')[0]
                // SubGroupsMap
                filteredList.subGroupsMap[newGroup] = filteredList.subGroupsMap[grp.subGroupId]
                delete filteredList.subGroupsMap[grp.subGroupId]
                // SubGroupId
                filteredList.subGroupId = filteredList.subGroupId.filter(x => x !== grp.subGroupId)
                filteredList.subGroupId.push(newGroup)
                // SubGroupManagement
                grp.subGroupId = newGroup
              } else {
                let newGroup = grp.subGroupId + "~~~" + grp.subGroupName
                // SubGroupsMap
                filteredList.subGroupsMap[newGroup] = filteredList.subGroupsMap[grp.subGroupId]
                delete filteredList.subGroupsMap[grp.subGroupId]
                // SubGroupId
                filteredList.subGroupId = filteredList.subGroupId.filter(x => x !== grp.subGroupId)
                filteredList.subGroupId.push(newGroup)
                // SubGroupManagement
                grp.subGroupId = newGroup
              }
            }
          })
          // filteredList.subGroupManagement.map(x => {
          //   x.isReadOnly = filteredList.subGroupsMap[x.subGroupId]
          //   if (x.subGroupId.indexOf("~~~") > -1) {
          //     x.subGroupName = x.subGroupId.split("~~~")[1];
          //   } else {
          //     let grp = self.currGroupDetails.filter(g => g.id === x.subGroupId)[0]
          //     if (grp) {
          //       x.subGroupName = grp._embedded.group.profile.name
          //     } else {
          //       console.log(x)
          //     }
          //   }
          // })
          idmApi.addToAdminConfigDB(`${apiUrl}/auth/appGroupNew`, [filteredList]).then(function (response) {
            self.loading = false
            self.showDropdownForGroups = false
            self.showDropdownForSelfGroups = false
            var el = document.getElementById("search-criteria")
            el.value = ''
            $(".searchbox .list").each(function () {
              var s = $(this).text().toLowerCase();
              // console.log(s + '\n' + el)
              $(this).closest('.searchbox')[ s.indexOf(el.value) !== -1 ? 'show' : 'hide' ]();
            });
            console.log(el.value)
            self.getConfigList()
            self.updateAdminConfigsInLocal()
            if (response.data.status.statusCode === "500") {
              window.alert(response.data.status.status)
            } else {
              setTimeout(function() {
                self.saveSuccess = true;
                self.showAppList = true;
                self.applicationIndex = 0
              }, 500)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          self.loading = false
        }
      },
      populateOptionDetails(appId, index) {
        var self = this
        self.clearMessages()
        self.appsGroups[appId].some(function(i) {
          if (i.id === self.appAdminGroupModal[index].groupId) {
            self.appAdminGroupModal[index].groupId = i._embedded.group.id
            return true
          }
        })
        self.appsSelfGroups[appId].some(function(i) {
          if (i.id === self.appAdminGroupModal[index].groupId) {
            self.appAdminGroupModal[index].groupId = i._embedded.group.id
            return true
          }
        })
        /* self.appList.some(function(i) {
          if (i.id === appId) {
            self.appAdminGroupModal[index].application.applicationName = i.label
            return true
          }
        }) */
      },
      removeRow(appgrpId, index, gn) {
        var self = this
        self.currRemoveId = appgrpId
        self.currRemoveIndex = index
        if (gn === onecargillappid) {
          self.clearMessages()
          $('.cannotDeleteModal').modal('show')
        } else {
          self.clearMessages()
          $('.deleteConfirmModal').modal('show')
        }
      },
      removeConfirm() {
        var self = this
        self.loading = true
        self.appAdminGroupModal.splice(self.currRemoveIndex, 1)
        self.appNameList.splice(self.currRemoveIndex, 1);
        var data = {"appGrpId": self.currRemoveId}
        // delete from db
        idmApi.deleteAdminConfig(`${apiUrl}/auth/appGroupNew`, data).then(function (response) {
          self.loading = false
          self.applicationIndex = 0
          $('.deleteConfirmModal').modal('hide')
          self.deleteSuccess = true
          var el = document.getElementById("search-criteria")
          el.value = ''
          $(".searchbox .list").each(function () {
            var s = $(this).text().toLowerCase();
            // console.log(s + '\n' + el)
            $(this).closest('.searchbox')[ s.indexOf(el.value) !== -1 ? 'show' : 'hide' ]();
          });
          self.updateAdminConfigsInLocal()
          self.getConfigList()
        }).catch(err => {
          console.log(err)
        })
      },
      cancelRemove() {
        $('.deleteConfirmModal').modal('hide')
      },
      clearMessages() {
        var self = this
        self.isIncomplete = false
        self.saveSuccess = false
        self.deleteSuccess = false
      },
      isAlreadyConfiged(id) {
        var self = this
        var listOfConfigedApps = self.appAdminGroupModal.map(function(i) {
          return i.applicationId
        })
        return (id === onecargillappid && listOfConfigedApps.indexOf(id) > -1)
      },
      updateAdminConfigsInLocal() {
        var self = this
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupListNew`).then(function (response) {
          self.loading = false;
          self.getNamesOfApp()
          self.persistInLocal(response)
        }).catch(err => {
          console.log(err)
        })
      },
      persistInLocal(response) {
        var adminGroupsArr = []
        var adminAppsArr = []
        adminGroupsArr = response.data.map(function(i) {
          return i.groupId
        })
        adminAppsArr = response.data.map(function(i) {
          return i.applicationId
        })
        storage.set('adminConfigMaster', JSON.stringify(response.data))
        storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
        storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
      }
    },
    data() {
      return {
        brandDetails: brandDetails,
        additionalGroup: [],
        additionalSelfGroup: [],
        showDropdownForGroups: false,
        showDropdownForSelfGroups: false,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        userId: '',
        loading: false,
        user_lang: {},
        prefLang: 'en_US',
        email: '',
        clientList: [],
        appList: [],
        appsGroups: {},
        appsSelfGroups: {},
        appGroupsArrayMap: {},
        modalObj: {},
        selectModel: {},
        optionModel: {},
        appAdminGroupModal: [{"applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], "subGroupsMap": {}, isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false}],
        rowObj: {"applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], "subGroupsMap": {}, isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false},
        isIncomplete: false,
        saveSuccess: false,
        deleteSuccess: false,
        currRemoveId: '',
        currRemoveIndex: '',
        appNameList: [],
        showAppList: true,
        applicationIndex: 0,
        isNewAppConfig: false,
        groupNameTyped: "",
        timer: 0,
        isSearched: false,
        searchDropdownData: [],
        currGroupDetails: [],
        currGroupIds: [],
        tempAppAdminGroupModal: [
          {
            applicationId: "undefined",
            brand: "cargill",
            groupId: "",
            subGroupId: [],
            subGroupsMap: {},
            isDxp: false,
            email: "undefined",
            isSelfReg: false,
            maxSelfRegCount: 0,
            selfRegGroupList: [],
            selfRegGroupId: "undefined",
            isSelfRegModal: false,
            emailId: "",
            disableExistingUserOnboard: false
          }
        ]
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
    padding: 0;
  }
.custom-select {
	display: inline-block;
	max-width: 100%;
	height: calc(2.50rem + 2px);
	padding: 0.375rem 1.75rem 0.375rem 0.75rem;
	line-height: 1.25;
	background-color: #ececeb;
	vertical-align: middle;
	background-size: 8px 10px;
	border: 1px solid #00524A;
	border-radius: 0;
	-moz-appearance: none;
	-webkit-appearance: none;
}
.card-block {
	background: #eceff1;
}
.user-input {
	width: 100%;
	background: #ffffff;
	color: #333333;
	height: 30px;
}
.user-select {
	color: #333333;
	height: 30px;
}
#userSearch {
	margin: 10px;
}
.good-table th {
	color: #333333 !important
}
.btn-secondary:active {
	background: #007299;
	box-shadow: none;
}
.btn-secondary {
	background: var(--theme-primary);
	color: #ffffff;
}
input {
	width: 130px;
	box-sizing: border-box;
	border: 1px solid var(--theme-primary);
	border-radius: 0;
	font-size: 16px;
	background-color: #f1f1f1;
	background-position: 10px 10px;
	background-repeat: no-repeat;
	padding: 15px 20px;
	height: 50px;
}
.card {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	background-color: #33373D;
	border: 0px solid rgba(0, 0, 0, 0.125);
	border-radius: 0px;
	box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px
		rgba(0, 0, 0, 0.22);
	box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);
}
.card {
	margin-bottom: 1rem;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.card-block1 {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0rem;
}
#searchId {
	box-sizing: border-box !important;
	border: 2px solid #dde3e6 !important;
	border-radius: 0 !important;
	background-color: #fff !important;
	background-position: 10px 10px !important;
	background-repeat: no-repeat !important;
	height: 40px !important;
	margin-bottom: 18px !important;
	margin-left: 30px !important;
}
.filter-label{ width: 150px;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    font-weight: bold;
}
.btn-secondary {
	background-color: var(--theme-primary);;
	border-color: #00433c;
}
.btn-secondary:hover {
	background-color: #00524A;
	border-color: #00433c;
}
.btn {
	padding: 14px 24px;
	border: 0 none;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
}
/* Pills styles */
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#fff;
    color: var(--theme-primary);
    width: 15rem;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 15rem;
}
.nav-pills .nav-link:hover {
    padding: 15px 30px;
    border-top: 1px solid #00524A;
    border-right: 1px solid #00524A;
    border-left: 1px solid #00524A;
    border-bottom: 1px solid var(--theme-primary);
    background-color:#00524A;
    color:#fff;
    width: ;
}
.nav-pills .nav-link.active:hover {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#FFF;
    color: var(--theme-primary);
    width: ;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    background-color:#00524A;
    color: #fff;
}
.nav-tabs .nav-link {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.nav-link:focus, .nav-link:hover {
    text-decoration: none;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575px) {
.nav-pills, .nav-link {
  width: 100%;
}
.nav-item {
  margin: 5px 0 0 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .nav-pills, .nav-link {
  width: 100%;
}
  .nav-item {
    margin: 0 0 0 1px;
}
.nav-link {
    margin: 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
.input-adduser{
    height: initial;
    padding: 5px 15px;
    width: 100%;
	background: #fff;
	margin: 0px !important
}
.input-checkbx-sub{
width: 20px;
height: 20px !important;
display: inline-block;
}
.preflang{
    width: 100%;
    min-height: 34px;
	}
.success-bg{
    background: #90ee90;
}
.error-bg{
   background: #ffc0cb;
}
.form-control-label{min-width: 120px;font-size:12px;}
.wrap-input{display:block;overflow:hidden}
.form-wrap{    margin-bottom: 3px;}
.create-btn{margin-top: 10px;
    height: 40px;
    line-height: 0px;font-size: 12px;float:right;}
.search-icon{margin-top: 10px;
    margin-top: 0px;
    height: 40px !important;
    line-height: 0px;
    padding: 12px 24px 14px 24px;
	margin-bottom: 10px;
    border-radius: 0px;}
.tableContainer{padding: 0px 15px 30px;    overflow-x: auto;}
.input-group{
    width: 100%;
    background: #fff;
    margin: 0px -15px 0p;
    padding: 5px;
    outline: 15px solid #fff;
    /* margin: 0px -15px; */
}
.input-group-btn {max-width:65px}
.sub-group{display: inline-block}
@media (max-width: 1050px) {
  .input-group {
    width:100% !important;
	display: block;
  }
}
@media (max-width: 768px) {
  .sub-group {
    width:100% !important;
	display: block;
  }
  .searchId{max-width: 230px;}
  .filter-text{margin-left: 0px !important}
  .adduser-btn{margin-left: 0px !important}
}
.dropdown div, .dropdown dt {
    margin:0px;
    padding:0px;
}
.dropdown ul {
    margin:0px;
    padding:0px;
}
.dropdown div {
    position:relative;
    margin:0px;
    padding:0px;
}
.dropdown a, .dropdown a:visited {
    color:#fff;
    text-decoration:none;
    outline:none;
    margin:0px;
    padding:0px;
    min-height: 30px;
    border-radius: 3px;
}
.dropdown div a {
    background-color:#4F6877;
    display:block;
    overflow: hidden;
    width:100%;
    margin:0px;
    padding:0px;
}
.dropdown div a span, .multiSel span {
    cursor:pointer;
    display:inline-block;
    margin:0px;
    padding:5px 10px;
}
.dropdown div ul {
    background-color: #4F6877;
    top:1px;
    color:#fff;
    display:none;
    position:absolute;
    width:100%;
    list-style:none;
    height: 100px;
    overflow: auto;
    margin:0px;
    padding:0px;
}
.dropdown span.value {
    display:none;
    border-radius: 3px;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a {
    display:block;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a:hover {
    background-color:#fff;
    margin:0px;
    padding:0px;
}
.selectDropDown{border: 2px solid #dde3e6;height:40px;
    /* border-radius: 3px; */
    cursor: pointer;
    background: #fff;
	width: 100%;}
.searchDropDown{
  border: 2px solid #dde3e6;
  background: #fff;
	width: 100%;
  min-height: 40px;
  padding: 10px;
}
#checkboxlist{position: relative;
    margin-top: 0px;
	background:#fff;
	border: 1px solid #ccc;
	min-width: 200px;}
#checkboxlistself {
  position: relative;
  margin-top: 0px;
	background:#fff;
	border: 1px solid #ccc;
	min-width: 200px;
}
.dd-list-item:hover{background:#fff}
button {background:var(--theme-primary) !important}
.adduser-btn{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;}
input, select{
background: #fff!important;
    border: 2px solid #dde3e6!important;
	padding-left: 10px !important;
    font-size: 14px !important;}
.bc{font-size:10px;font-weight:bold;}
.bc-adduser{font-size:10px;font-weight:bold;margin:15px}
.bc-nav:hover{text-decoration:underline; cursor:pointer}
.user-creds{background:#fff;    padding: 5px 10px 10px;
    margin-bottom: 12px;}
.bb0{border-top:0px !important}
.add-group{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.remove-group{color: #d80842;
    font-size: 20px;
    /* float: right; */
    margin-top: 6px;
    cursor: pointer;}
.group-div{border:2px solid #eceff1;padding: 3px 10px;}
.group-name{display: inline-block;width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
.usercreateinfo{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;}
@media screen and (max-width: 767px) {
.main-content{padding-top:25px}
.main-content{padding-left:0px}
}
@media screen and (min-width: 768px) {
.main-content{padding-top:0px}
.main-content{padding-left:200px}
}
@media screen and (min-width: 991px) {
.search-bar-wrapper{width: 100%}
.search-bar-select{width: 300px;}
}
@media screen and (max-width: 991px) {
.search-bar-wrapper{width: 75%}
.search-bar-select{width: 150px;}
}
.cancel-btn{    float: right;
    display: block;
    padding: 18px 30px;}
input, select { height: 32px !important; color: #000 !important}
button { height: 32px !important; color: #fff !important}
.disabled {pointer-events:none;opacity:0.5}
.disabledLight {pointer-events:none;opacity:0.8}
.error{    color: red;width: 100%;
    margin-left: 15px;}
.pwderror{max-width:initial;width:100%;font-size: 14px;}
.codeVerifybtn{
background:#f9f9f9;
color:#595959;
border:1px solid #c3c3c3;
font-size:13px;
display: inline-block !important;
 margin-top: -2px;
 height: 30px;
 line-height: 14px;
 width: 87px;}
.fa-check-circle {font-size:40px !important}
label{margin-bottom:0px !important;font-weight:normal !important;font-size:13px;}
user-creds label{font-weight: normal !important;}
.sometext-hidden{
-webkit-user-select: none; /* Chrome/Safari */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+ */
}
.configGroupAdmin tr, td, th{padding-top: 5px;padding-bottom:5px;}
.configGroupAdmin tr{border-bottom: 1px solid #eceff1;}
.configGroupAdmin th {padding: 10px !important;}
.addgrouptxtbox{
  width: 75%;
  border: #ccc 1px solid !important;
  border-radius: 2px;
  margin-top: 5px;
  font-size: 15px !important;
}
.deleteconfig{
margin-right: 15px;
line-height: 13px;
cursor:pointer;
padding: 6px;
font-size: 13px;
 border-radius: 3px;
 background: #bf6161  !important;
 box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;
 max-height: 30px;
 margin-top: 2px;
 }
 input[type=text]:focus
{  
  border-color: #dde3e6 !important;
}
.app-name {
  padding-top: 5px;
}
.app-name:hover {
  text-decoration: underline;
  color: blue;
}
.dropdownWrap {
  width:75% !important; 
  height: 40px !important; 
  padding: 7px !important; 
  font-size: 1rem !important;
}
.search-app {
  width: 70%;
  font-size: 1rem !important;
  border: 0 !important;
  border-bottom: 1px solid #ccc !important;
  display: inline;
}
.appDetails {
  padding: 10px 0px;
  color: #658d1b;
  font-weight: 600;
  background: #fafafa;
  width: 100%;
}
.search-list-for-admin {
  vertical-align: super;
  cursor: pointer;
  padding: 5px;
}
.search-list-for-admin:hover {
  background: #e3e2e24a;
  transform: scale(1.05);
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #658d1b;
}

input:focus + .slider {
  box-shadow: 0 0 1px #658d1b;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// TokenManager.vue?613cc048